import { render, staticRenderFns } from "./checkoutCounter.vue?vue&type=template&id=2d66cdd0&scoped=true&"
import script from "./checkoutCounter.vue?vue&type=script&lang=js&"
export * from "./checkoutCounter.vue?vue&type=script&lang=js&"
import style0 from "./checkoutCounter.vue?vue&type=style&index=0&id=2d66cdd0&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2d66cdd0",
  null
  
)

export default component.exports